module.exports = __webpack_public_path__ + "img/1585164178.3dd36da9.jpg";